import { render, staticRenderFns } from "./createRole.vue?vue&type=template&id=26a7e8fa&scoped=true"
import script from "./createRole.vue?vue&type=script&lang=js"
export * from "./createRole.vue?vue&type=script&lang=js"
import style0 from "./createRole.vue?vue&type=style&index=0&id=26a7e8fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a7e8fa",
  null
  
)

export default component.exports